import { matchPath } from 'react-router';

export default function getMatch(url, path) {
  return matchPath(url, { path });
}
